import { ClassTimestampsHelper } from '../ClassHelper';
import Account from '../account/Account';
import DateTZ from '../date/DateTZ';
import User from '../user/User';

class Collection extends ClassTimestampsHelper {
  constructor({ account, user, collector, date, status, amount, orders } = {}) {
    super(...arguments);
    this.account = this.ref(account, Account);
    this.user = this.obj(user, User);
    this.collector = this.obj(collector, User);
    this.date = this.obj(date, DateTZ);
    this.amount = amount;
    this.orders = orders;
    this.status = status;
  }
}

export default Collection;